import { canNavigateTo } from '@/lib/navigation-guards';
import { useRedirectStore } from '@/stores/redirect';
import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';

export function usePostLoginRedirect() {
  const { redirectPath, setRedirectPath } = useRedirectStore(
    useShallow(state => ({
      redirectPath: state.redirectPath,
      setRedirectPath: state.setRedirectPath,
    })),
  );
  const navigate = useNavigate();

  useEffect(() => {
    const run = async () => {
      if (redirectPath) {
        // Only allow relative paths: must start with "/" and have no scheme or protocol-relative prefix.
        const isSafe =
          redirectPath.startsWith('/') &&
          !/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(redirectPath) &&
          !redirectPath.startsWith('//');

        if (isSafe) {
          try {
            const currentFull =
              typeof window !== 'undefined'
                ? `${window.location.pathname}${window.location.search}${window.location.hash}`
                : '';
            const redirectUrl = typeof window !== 'undefined' ? new URL(redirectPath, window.location.origin) : null;
            const redirectFull = redirectUrl
              ? `${redirectUrl.pathname}${redirectUrl.search}${redirectUrl.hash}`
              : redirectPath;

            if ((typeof window === 'undefined' || currentFull !== redirectFull) && canNavigateTo(redirectPath)) {
              await navigate({ to: redirectPath, replace: true });
            }
          } catch {
            if (
              (typeof window === 'undefined' || window.location.pathname !== redirectPath) &&
              canNavigateTo(redirectPath)
            ) {
              await navigate({ to: redirectPath, replace: true });
            }
          }
        }
        setRedirectPath(null);
      }
    };
    void run();
  }, [redirectPath, navigate, setRedirectPath]);
}
